import { Button, Modal } from 'antd';
import React from 'react';

interface DownloadDataModalProps {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  timeInfo?: string;
}

export default function DownloadDataModal({
  isVisible,
  setIsVisible,
  timeInfo,
}: DownloadDataModalProps) {
  return (
    <Modal
      closable={false}
      keyboard={false}
      open={isVisible}
      title={'Successfully created request for spectra files'}
      onOk={() => {
        setIsVisible(false);
      }}
      footer={[
        <Button
          key='ok'
          onClick={() => {
            setIsVisible(false);
          }}
        >
          {' '}
          Ok{' '}
        </Button>,
      ]}
    >
      {`An email with a link to download the data will be sent to you within ${
        timeInfo || '15 minutes'
      }.`}
    </Modal>
  );
}
